module.exports = __webpack_public_path__ + "static/media/copy.883d36ca.svg";